import { createDecorator } from '../../../../platform/instantiation/common/instantiation.js';
const IViewsService = ( createDecorator('viewsService'));
export { IViewsService };
